export * from './kunden-arts-list.component';
export * from './kunden-arts-list.component.module';